import { atom } from 'jotai';
import { competitionsAtom } from '@/atoms/queries/competitions';
import { optionsAtomCallback } from '@/utils/atoms/generic';

export const eventDataCompetitionsOptionsAtom = atom(async get =>
  optionsAtomCallback(competitionsAtom, 'name', 'competition_id', get, ['area_code', 'is_360', 'is_physical']),
);
